<template>
	<div class="ms-cell-editor">
		<div
			v-show="!isSelected || readOnly || !editable"
			class="flex-center"
			:class="{ 'edit-disabled': readOnly, 'ms-editor-text': editable }"
		>
			<div class="editor-display text-right">
				<span>{{
					dataRow[col.dataField] | formatData({ formatType: col.formatType })
				}}</span>
			</div>
			<div
				class="icon-input float-right"
				v-tooltip="{ content: cellErrorProvider.message, classes: 'error' }"
				v-if="cellErrorProvider.isValid"
			>
				<div class="mi mi-20 mi-icon-error mr-2"></div>
			</div>
		</div>
		<div
			class="ms-editor w-full h-full"
			ref="editor"
			v-show="isSelected && !readOnly && editable"
		></div>
	</div>
</template>
<script>
import msCellInput from './msCellInput';
import msNumber from '@/components/msnumber/msNumber.vue';
export default {
	name: 'MsCellNumber',
	extends: msCellInput,
	created() {
		const me = this;
		if (!me.dataRow[me.col.dataField]) {
			me.$set(me.dataRow, me.col.dataField, 0);
		}
	},
	methods: {
		/**
		 * Hàm để lấy component cần sử dụng
		 * @returns component được import để sử dụng
		 * Created by LTDAT(30.06.2020)
		 *  */
		getEditorControl() {
			return msNumber;
		},
		customBeforeEdit() {
			const me = this;
			if (!me.dataRow[me.col.dataField]) {
				me.$set(me.dataRow, me.col.dataField, 0);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.editor-display {
	padding: 6px;
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 50px;
	overflow: hidden;
}
</style>

